import * as React from 'react';
import { CALENDAR_FILTER } from '../../../../consts/calendar';
import { FilterType } from './Calendar';
import {
  isAllFilter,
  isClubEventsFilter,
  isSportEventsFilter,
  isTournamentEventsFilter
} from '../../../../helpers/calendar/calendar';
import { AppUser } from '../../../App/App';

interface Props {
  onFilterButtonClick: (filter: FilterType) => void;
  filter: FilterType;
  user: AppUser;
}

const ALL_OPTIONS: { value: FilterType; label: string; kind: string }[] = [
  { value: CALENDAR_FILTER.ALL as FilterType, label: 'All events', kind: 'all' },
  { value: CALENDAR_FILTER.SPORT_EVENTS as FilterType, label: 'Fixtures', kind: 'fixture' },
  { value: CALENDAR_FILTER.CLUB_EVENTS as FilterType, label: 'Clubs', kind: 'club' },
  { value: CALENDAR_FILTER.TOURNAMENT_EVENTS as FilterType, label: 'Tournament events', kind: 'tournamentEvent' }
];

export function CalendarFilterButtons(props: Props) {
  const { onFilterButtonClick, filter } = props;

  const isActive = (value: FilterType): boolean => {
    switch (value) {
      case CALENDAR_FILTER.ALL:
        return isAllFilter(filter);
      case CALENDAR_FILTER.SPORT_EVENTS:
        return isSportEventsFilter(filter);
      case CALENDAR_FILTER.CLUB_EVENTS:
        return isClubEventsFilter(filter);
      case CALENDAR_FILTER.TOURNAMENT_EVENTS:
        return isTournamentEventsFilter(filter);
      default:
        return false;
    }
  };

  return (
    <div className="cal-filters">
      <div className="cal-filters__desktop">
        {ALL_OPTIONS.map(option => {
          const active = isActive(option.value);
          return (
            <button
              key={option.value}
              type="button"
              className={`cal-pill cal-pill--${option.kind}${active ? ' cal-pill--on' : ''}`}
              onClick={() => onFilterButtonClick(option.value)}
            >
              {option.kind !== 'all' ? <span className="cal-pill__dot" aria-hidden="true" /> : null}
              {option.label}
            </button>
          );
        })}
      </div>

      <div className="cal-filters__mobile">
        <div className="cal-selectWrap">
          <select
            className="cal-select"
            value={filter}
            onChange={e => onFilterButtonClick(e.target.value as FilterType)}
          >
            {ALL_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <svg className="cal-selectChevron" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 8l5 5 5-5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
    </div>
  );
}
